﻿import { ajaxPost } from '../../utils/ajax';
import { mapGetters, mapState } from 'vuex';
export default {
name: 'di-page-overview-b2c',
    props: ['blockid','viewmodel'],

    created() {
    }, 
    mounted() {
        //this.model = this.viewmodel;
    },
computed:
    Object.assign(
        mapState({
            overview: state => state.digitalvalidation.pageOverview
        })
    )
,
data: () => ({
    model: {
            
    }        
}),
    methods: {               
       
    },
ready: function() {        
}
}